<!-- Modal.svelte -->
<script>
  import { fade } from 'svelte/transition';
  import { createEventDispatcher } from 'svelte';
  
  const dispatch = createEventDispatcher(); 

  export let handleSubmitLive;
  export let antalReduceradeRader;
  export let submittedLive;
  export let responseLive;
  
  export let showModal = false; // Now received as a prop
  let value1 = '';
  let value2 = 0;
  let value3 = '';

  function closeModal() {
    dispatch('close'); // Dispatch event instead of directly modifying showModal
  }

</script>

{#if showModal}
  <div class="modal-backdrop" on:click={closeModal} transition:fade>
    <div class="modal" on:click|stopPropagation>
      {#if !submittedLive}
        <h2>Lämna in spel till liverättning</h2>
        
        <div class="form-group">
          <label for="value1">Namn:</label>
          <input id="value1" type="text" bind:value={value1}>
        </div>


         <div class="couponCharDist">
			<label class="switch">
			  <input 
			  	type="checkbox" 
			  	checked={value2 === 1}
  				on:change={(e) => value2 = e.target.checked ? 1 : 0}>
			  <span class="slider round"></span>
			</label>
			 Spelläggare
		</div>
        
        <div class="buttons">
          <button on:click={closeModal}>Cancel</button>
          <button on:click={handleSubmitLive(value1,value2,antalReduceradeRader)} class="primary">OK</button>
        </div>
      {:else}
        <div class="success-message">
          <h2>Success!</h2>
          <p>Your values have been submitted successfully.</p>
          <button on:click={closeModal}>Close</button>
          <a href="https://reducera2.gamblingcabin.se/app/TGC" target="_blank" class="duckduckgo-link">
            Gå till liverättning!
          </a>
<!--           {#if responseLive}
          {responseLive}
          {/if} -->
        </div>
      {/if}
    </div>
  </div>
{/if}

<style>
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
  vertical-align: text-top;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
}

input:checked + .slider {
  background-color: var(--themeColor1);
}

input:focus + .slider {
  box-shadow: 0 0 1px var(--themeColor1);
}

input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}


  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: white;
    padding: 20px;
    border-radius: 4px;
    width: 90%;
    max-width: 500px;
  }

  .form-group {
    margin: 15px 0;
  }

  .form-group label {
    display: block;
    margin-bottom: 5px;
  }

  .form-group input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }

  .buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
  }

  button {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  button.primary {
    background: var(--themeColor1);
    color: white;
  }

  button:hover {
    opacity: 0.9;
  }

  .success-message {
    text-align: center;
    padding: 20px;
  }

  .duckduckgo-link {
    display: inline-block;
    margin-top: 15px;
    padding: 10px 20px;
    background: var(--themeColor1);
    color: white;
    border-radius: 15pt;
    text-decoration: none;
    transition: background 0.2s;
  }

  .duckduckgo-link:hover {
    background: #C14B2D;
  }
</style>